import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '../UI/dialog';
import BotonAcceso from '../elementos/BotonAcceso';

const PedidoRealizadoModal = ({ show, handleClose }) => {
  return (
    <Dialog open={show} onOpenChange={(open) => (!open ? handleClose() : null)}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Aviso</DialogTitle>
          <DialogDescription>
            Usted ya realizó su pedido. Si desea modificarlo:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
            <ol className="space-y-2 text-gray-700">
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white text-sm font-bold rounded-full flex items-center justify-center">1</span>
                <span>Ve a <strong className="text-blue-700">"Mi pedido semanal"</strong> en el menú</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white text-sm font-bold rounded-full flex items-center justify-center">2</span>
                <span>Haz clic en <strong className="text-blue-700">"Editar pedido semanal"</strong></span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white text-sm font-bold rounded-full flex items-center justify-center">3</span>
                <span>Modifica lo que necesites y guarda</span>
              </li>
            </ol>
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <div>
                <p className="text-amber-800 font-semibold mb-1">⚠️ Importante:</p>
                <p className="text-amber-700 text-sm">
                  Solo puedes modificar hasta la fecha límite configurada para cada semana. Consulta con el administrador para conocer los plazos.
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <BotonAcceso variant="accent" onClick={handleClose}>
            Entendido
          </BotonAcceso>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PedidoRealizadoModal;
